export const PLACER_URL = 'https://www.placer.ai';
